export const floatingButtonStyles =
   'fixed cursor-pointer right-[24px] z-40 w-[80px] h-[80px] bottom-[24px]'
